// store/slices/captionSlice.ts
import { StateCreator } from "zustand";

export interface CaptionState {
  caption: string | null;
  isLoading: boolean;
  error: string | null;
  lastGenerated: string | null;
}

export interface CaptionSlice {
  captions: { [postId: string]: CaptionState };
  setPostCaption: (postId: string, caption: string) => void;
  setPostCaptionLoading: (postId: string, isLoading: boolean) => void;
  setPostCaptionError: (postId: string, error: string | null) => void;
  clearPostCaption: (postId: string) => void;
  clearAllCaptions: () => void;
}

export const createCaptionSlice: StateCreator<CaptionSlice> = (set) => ({
  captions: {},

  setPostCaption: (postId, caption) =>
    set((state) => ({
      captions: {
        ...state.captions,
        [postId]: {
          ...state.captions[postId],
          caption,
          isLoading: false,
          error: null,
          lastGenerated: new Date().toISOString(),
        },
      },
    })),

  setPostCaptionLoading: (postId, isLoading) =>
    set((state) => ({
      captions: {
        ...state.captions,
        [postId]: {
          caption: state.captions[postId]?.caption || null,
          isLoading,
          error: isLoading ? null : state.captions[postId]?.error || null,
          lastGenerated: state.captions[postId]?.lastGenerated || null,
        },
      },
    })),

  setPostCaptionError: (postId, error) =>
    set((state) => ({
      captions: {
        ...state.captions,
        [postId]: {
          ...state.captions[postId],
          error,
          isLoading: false,
        },
      },
    })),

  clearPostCaption: (postId) =>
    set((state) => {
      const newCaptions = { ...state.captions };
      delete newCaptions[postId];
      return { captions: newCaptions };
    }),

  clearAllCaptions: () => set(() => ({ captions: {} })),
});
